import { render, staticRenderFns } from "./datacollect-detail.vue?vue&type=template&id=6c1cffe5&scoped=true&"
import script from "./datacollect-detail.vue?vue&type=script&lang=ts&"
export * from "./datacollect-detail.vue?vue&type=script&lang=ts&"
import style0 from "./datacollect-detail.vue?vue&type=style&index=0&id=6c1cffe5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1cffe5",
  null
  
)

export default component.exports